import { ApiEpOrganization } from "@smp/api";
import { UiBox } from "@smp/ui";
import clsx from "clsx";
import { useCallback, useMemo } from "react";
import { useQuery } from "react-query";

import { useContextApp } from "@/screens/app/context/app";
import { useVirtualPortalExit } from "@/utils/virtualPortal";
import { yaReachGoal } from "@/utils/ya_reach_goal";

import { Advisor } from "./advisor";
import { ControlsBilling } from "./controls_billing";
import { ControlsNotifications } from "./controls_notifications";
import { ControlsOrganization } from "./controls_organization";
import { ControlsTokens } from "./controls_tokens";
import { ControlsUser } from "./controls_user";
import { useStyles } from "./header.css";

export const Header = () => {
  const {
    state: { isExpanded, me, organizationId },
    refs: { header },
  } = useContextApp();
  const classes = useStyles();
  const replacementContent = useVirtualPortalExit("HEADER");

  const { data: organization } = useQuery(
    ["ep.organization", { id: organizationId }],
    organizationId
      ? () => ApiEpOrganization.retrieve({ id: organizationId })
      : () => undefined,
  );

  const handleClickControlsBilling = useCallback(() => {
    yaReachGoal("header_billing_button", undefined, true);
  }, []);

  return useMemo(
    () => (
      <div
        className={clsx(classes.header, {
          [classes["header--expanded"]]: isExpanded,
        })}
      >
        {replacementContent || (
          <>
            <ControlsOrganization />

            <UiBox flexGrow={1} />

            <div ref={header} />

            <div className={classes.header__buttons}>
              {(!organization || organization.owner?.id === me.id) && (
                <>
                  <ControlsTokens />
                  <UiBox onClick={handleClickControlsBilling}>
                    <ControlsBilling />
                  </UiBox>
                </>
              )}

              <ControlsNotifications />

              <Advisor />

              <ControlsUser />
            </div>
          </>
        )}
      </div>
    ),
    [
      classes,
      handleClickControlsBilling,
      header,
      isExpanded,
      me.id,
      organization,
      replacementContent,
    ],
  );
};
